<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'TlbsRadioGroup',
  
})
</script>
<template>
  <RadioGroup
    class="tlbs-radio-group"
    :model-value="initVal"
    :default-value="props.modelValue"
    v-bind="$attrs"
    @change="onChange"
  >
    <div v-if="props.options.length">
      <div v-if="props.type === 'button'">
        <RadioButton
          v-for="item in props.options"
          :key="item.value"
          class="tlbs-radio-button"
          :value="item.value"
        >
          {{ item.label }}
        </RadioButton>
      </div>
      <div v-else>
        <Radio
          v-for="item in props.options"
          :key="item.value"
          class="tlbs-radio"
          :value="item.value"
        >
          {{ item.label }}
        </Radio>
      </div>
    </div>
  </RadioGroup>
</template>

<script setup lang="ts" name="TlbsRadioGroup" >
import { RadioGroup, RadioButton, Radio } from 'tdesign-vue-next';
interface Option {
  value: string | number | boolean;
  label: string;
  disabled: boolean;
}

interface Props {
  modelValue: string | number | boolean;
  options: Option[];
  type?: 'radio' | 'button';
}
// const attrs = useAttrs();
// console.log('attrs', attrs);
const props = withDefaults(defineProps<Props>(), {
  modelValue: undefined,
  options: () => [],
  type: 'radio',
});
const emit = defineEmits<(e: 'update:modelValue' | 'change', value: string | number | boolean) => void>();

const initVal = ref(props.modelValue);

watch(() => props.modelValue, (newVal) => {
  initVal.value = newVal;
  emit('update:modelValue', newVal);
});
const onChange = (value: string | number | boolean) => {
  initVal.value = value;
  emit('update:modelValue', value);
  emit('change', value);
};

</script>
